import React from "react";
import FlipCard from "../../../Components/FlipCard/FlipCard";
import courses from "../../../data/courses";

const Courses = () => {
  const createCards = (course) => {
    return (
      <FlipCard
        key={course.id}
        title={course.title}
        instructor={course.instructor}
        courseLogoPath={course.courseLogoPath}
        courseLogoAlt={course.courseLogoAlt}
        providerLogoPath={course.providerLogoPath}
        providerLogoAlt={course.providerLogoAlt}
      />
    );
  };
  return (
    <div className="courses">
      <div className="courses-title">Courses</div>
      <div className="courses-cards row">{courses.map(createCards)}</div>
    </div>
  );
};

export default Courses;
